<div class="data-grid">
  <div *ngIf="isTariffAbsent" class="tariff-status-tooltip">
    Внимание! Отсутствует тариф!
  </div>
  <div class="label">Код инструмента</div>
  <div class="info">{{ instrument.instrumentCode }}</div>
  <div *ngIf="basisDetails?.manufacturers?.length" class="label">Завод</div>
  <div *ngIf="basisDetails?.manufacturers?.length" class="info">
    {{ basisDetails?.manufacturers?.join(', ') }}
  </div>
  <div *ngIf="instrument.shipmentTime" class="label">Срок отгрузки</div>
  <div *ngIf="instrument.shipmentTime" class="info">
    {{ instrument.shipmentTime }}
  </div>
  <div *ngIf="instrument.deliveryTime" class="label">Дней в пути</div>
  <div *ngIf="instrument.deliveryTime" class="info">
    {{ instrument.deliveryTime }}
  </div>
  <div class="label">Спрос</div>
  <div class="info">{{ instrument.bestBuyPrice }}</div>
  <div class="label">Предложение</div>
  <div class="info">{{ instrument.bestSellPrice }}</div>
  <div *ngIf="hasForecast" class="label">
    Прогноз на {{ instrument.forecast?.date | date: 'dd.MM.yyyy' }}
  </div>
  <div
    *ngIf="hasForecast"
    class="trend-color trend-color--{{ forecastColor }} info"
  >
    {{ forecastDescription }}
  </div>
</div>
